module.exports = __webpack_public_path__ + "img/flag_br.119018a.png";